import { BiSort } from 'react-icons/bi';
import { FaArrowDownLong, FaArrowUpLong } from 'react-icons/fa6';

interface GENERALInterface {
  itemsperpage?: any,
  startPage?: any,
  priceMin?: any,
  priceMax?: any,
  // tableOrder?: any,
  // tableSortBy: string,
  // SortableColumns: Array<any>,
  errors?: {
    [key: string | number]: string
  }
  // productOrder?: {
  //   [key: string | number]: string
  // }
}

export const GENERAL: GENERALInterface = {
  itemsperpage: 20,
  startPage: 1,
  priceMin: 0,
  priceMax: 10000,
  // productOrder: {
  //   asc: "ASC",
  //   desc: "DESC",
  //   ascIcon: FaArrowUpLong,
  //   descIcon: FaArrowDownLong,
  //   default: BiSort,
  // },
  // rates: {
  //   options: [
  //     { value: 5, label: "5.0" },
  //     { value: 4, label: "4.0 & up" },
  //     { value: 3, label: "3.0 & up" },
  //     { value: 2, label: "2.0 & up" },
  //     { value: 1, label: " 1.0 & up" },
  //   ],
  // },
  // productSortBy: "",
  errors: {
    500: "Something Went Wrong when loading data",
    404: "Not found",
    ERR_NETWORK: "Server unreachable",
    "*": "Unable to perform the request",
  },
};
